import type {
  ExpandableRowConfig,
  TreeNode,
} from '@commenda/kakashi';

import { IndirectTaxLiabilityReportHelper } from '../helpers';
import type { ContributionLiabilityReportTableRow } from '../types';

import { ContributionLiabilityExpandedContent } from './ContributionLiabilityExpandedContent';

export function createContributionTabExpandableRowConfig(): ExpandableRowConfig<
  TreeNode<ContributionLiabilityReportTableRow>
> {
  return {
    isEnabled: true,
    getRowId: (row) =>
      IndirectTaxLiabilityReportHelper.contributionRowFromExpandableTreeNode(row)
        .filingId,
    renderExpandedContent: (row) => (
      <ContributionLiabilityExpandedContent
        row={IndirectTaxLiabilityReportHelper.contributionRowFromExpandableTreeNode(
          row
        )}
      />
    ),
    maxExpandedHeight: 480,
    expandColumn: {
      sticky: 'left',
      ariaLabelToggle: 'Show filing details',
    },
  };
}
